export function getCircularReplacer() {
  // Rastreia apenas a cadeia de ancestrais do nó atual (não "tudo que já foi visto"),
  // usando o `this` que o JSON.stringify passa pro replacer (o objeto pai da chave atual)
  // pra desempilhar ao retroceder. Isso evita falso-positivo quando o MESMO array/objeto
  // é referenciado duas vezes em ramos diferentes da árvore (ex.: um array reaproveitado
  // em `draft_data` e também em outro campo do mesmo payload) — isso não é uma referência
  // circular de verdade, é só uma referência compartilhada, e não deveria virar texto.
  const ancestors: any[] = [];
  return function (this: any, _key: string, value: any) {
    if (typeof value !== "object" || value === null) {
      return value;
    }
    // Check for DOM nodes which are often the cause of circular structure errors in React events
    if (
      value instanceof Node ||
      (value.nodeType && typeof value.nodeName === "string")
    ) {
      return `[DOM Node: ${value.nodeName}]`;
    }
    if (value === window) {
      return "[Window]";
    }
    while (ancestors.length > 0 && ancestors[ancestors.length - 1] !== this) {
      ancestors.pop();
    }
    if (ancestors.includes(value)) {
      return "[Circular Reference]";
    }
    ancestors.push(value);
    return value;
  };
}

export function safeStringify(obj: any, space?: string | number): string {
  try {
    return JSON.stringify(obj, getCircularReplacer(), space);
  } catch (error) {
    return "[Unserializable Object]";
  }
}
